import {
  toWSDateString,
  WSTableCell,
  WSTableColumn,
  WSTableColumnSortDirection
} from "@wingspanhq/fe-component-library";
import { IPayableSchema } from "@wingspanhq/payments/dist/interfaces";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { IPayeeRow } from "../../../../services/search";
import { getPayeeNames } from "../../../Payees/selectors/getPayeeNames";
import { getWorkLogPayerStatusCellProps } from "../../utils/getWorkLogPayerStatusCellProps";
import { TableItemData } from "./TableWorkLogsPayerView";

type ColumnsConfig = {
  payeesMap: Map<string, IPayeeRow>;
  payablesMap?: Map<string, IPayableSchema>;
  onSortByUpdatedAt: (newDirection: WSTableColumnSortDirection) => void;
  updatedAtDirection?: WSTableColumnSortDirection;
};

export const getColumns = ({
  payeesMap,
  payablesMap,
  onSortByUpdatedAt,
  updatedAtDirection
}: ColumnsConfig): WSTableColumn<TableItemData>[] => [
  {
    config: {
      header: {
        text: "Contractor"
      }
    },
    renderFunction: item => {
      const payee = payeesMap.get(item.data.payeeId);
      if (!payee) {
        return <WSTableCell text="-" />;
      }
      const names = getPayeeNames(payee);
      return (
        <WSTableCell
          text={names.getResolvedName()}
          secondaryText={names.getResolvedSecondaryName()}
          truncationOptions={{
            text: { allowTwoLines: true }
          }}
        />
      );
    }
  },
  {
    config: {
      header: {
        text: "Work log #"
      }
    },
    renderFunction: item => <WSTableCell text={item.data.workLogNumber} />
  },
  {
    config: {
      header: {
        text: "Amount"
      }
    },
    renderFunction: item => (
      <WSTableCell text={formatMoney(item.data.amount, "USD")} />
    )
  },
  {
    config: {
      header: {
        text: "Last modified"
      },
      onColumnSort: onSortByUpdatedAt,
      sortDirection: updatedAtDirection
    },
    renderFunction: item => (
      <WSTableCell text={toWSDateString(item.data.updatedAt, "timeframe")} />
    )
  },
  {
    config: {
      header: {
        text: "Status"
      }
    },
    renderFunction: item => {
      const payable = payablesMap?.get(item.data.invoiceId || "");

      const cellProps = getWorkLogPayerStatusCellProps({
        workLog: item.data,
        payable
      });

      return <WSTableCell {...cellProps} />;
    }
  }
];
